import { useControllers } from "../state/controllers";
import { usePlaybackStore } from "../state/playbackStore";
import * as Tone from "tone";
import type { MetronomeMode } from "../state/playbackStore";

// play/pause + metronome cycling for the bottom play dock.
export function useTransport() {
  const c = useControllers();

  const toggle = async () => {
    const src = c.activeSource();
    if (src.isPlaying()) { src.pause(); return; }
    await src.play();
  };

  // metronome: off → overlay (clicks over the song) → solo (clicks only, own clock) → off.
  // Entering/leaving solo hands the play position (and playing state) between song and metronome.
  const metronome = usePlaybackStore((s) => s.metronome);
  const cycleMetronome = async () => {
    const order: MetronomeMode[] = ["off", "overlay", "solo"];
    const next = order[(order.indexOf(metronome) + 1) % order.length];
    await Tone.start();                                  // user gesture: unlock Web Audio for the clicks
    const from = c.activeSource();
    const pos = from.getPlaybackTime(), wasPlaying = from.isPlaying();
    const swaps = metronome === "solo" || next === "solo";
    if (swaps) from.pause();
    usePlaybackStore.getState().setMetronome(next);
    c.metro.resync();
    if (swaps) {
      const to = c.activeSource();
      to.seekSilent(pos);
      if (wasPlaying) await to.play();
    }
  };

  return { toggle, metronome, cycleMetronome };
}
